import { Box, Divider, IconButton, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import DrawerMenu from "../../components/drawer-menu/DrawerMenu";
import { useState } from "react";
import { SideBarItem } from "../../_styles/ListItem";
import { settingsOptions } from "./options";
import { Option } from "../../_styles/layout/Container";
import { useTranslation } from "react-i18next";

interface Props {
    selected: Option;
    handleChange: (option: Option) => void;
}

function SettingsMenu({ handleChange, selected }: Props) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    const handleMenu = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Box className="settings-menu-container">
            <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
                className="settings-menu-button"
                onClick={handleMenu}
                title="Settings"
                data-testid="settings-menu-button"
            >
                <MenuIcon />
            </IconButton>
            <DrawerMenu handleClose={handleClose} open={open}>
                <Box>
                    {settingsOptions.map((option) => (
                        <Box key={option.id}>
                            <SideBarItem
                                key={option.id}
                                onClick={() => {
                                    handleChange(option)
                                    setOpen(false);
                                }}
                                selected={selected?.id === option.id}
                                sx={{ marginBottom: 0, padding: '1.2rem 24px' }}
                                data-testid={`${option.id}-menu-link`}
                            >
                                {selected?.id === option.id ? option.selectedIcon : option.icon}
                                <div>
                                    <Typography paddingLeft={1} fontSize='18px'>{t(`SETTINGS_${option.name}_NAME`)}</Typography>
                                </div>
                            </SideBarItem>
                            <Divider />
                        </Box>
                    ))}
                </Box>
            </DrawerMenu>
        </Box>
    );
}

export default SettingsMenu;